import React, {useState} from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import {ReportForm} from "../../components";
import {AutocompleteInput, ReferenceInput, required, Title} from 'react-admin';
import env from "../../env/env";
import {downloadFilePost} from "../../components/FileDownload";

const BcKhaoSat = () => {
    const [formState, setFormState] = useState({
        pollId: null
    });
    const [loading, setLoading] = useState(false);


    const excelReport = async () => {
        setLoading(true)
        await downloadFilePost(`${env.reportURL}/reports/bc-khao-sat?pollId=${formState.pollId}`, 'bc_khao_sat.xlsx', null)
        setLoading(false)
    };

    const validate = (values) => {
        const errors = {};
        setFormState(prev => ({
            ...prev,
            ...values
        }));
        return errors;
    };


    return (
        <Card>
            <Title title="resources.bc-khao-sat.name"/>
            <CardContent>
                <ReportForm
                    params={{...formState}}
                    validate={validate}
                    excelReport={excelReport}
                    isLoading={loading}
                >
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={6}>
                            <ReferenceInput source="pollId"
                                            validate={required()}
                                            reference="polls"
                                            label="resources.polls.name">
                                <AutocompleteInput optionText="title"/>
                            </ReferenceInput>
                        </Grid>
                    </Grid>
                </ReportForm>
            </CardContent>
        </Card>
    )
}

export default BcKhaoSat

